import React from "react";
import { createRoot } from "react-dom/client";
import { tagSentryApp } from './sentry';
import App from './App';

tagSentryApp('main');

const container = document.getElementById("app");
if (container) {
  const root = createRoot(container);
  root.render(<App {...window.reactAppProps} />);
} else {
  console.error('Failed to find the app container');
}
